// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper___rk3V","col":"styles_col__1LE3j","fulfillmentStatus":"styles_fulfillmentStatus__145mn","emailCol":"styles_emailCol__2hqMQ"};